import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const Logo = ({ image, classOption, showText }) => {
    return (
        <Link className={`${classOption}`} to={process.env.PUBLIC_URL + "/"}>
            <div className="logo-container d-flex align-items-center">
                <img
                    className="sticky-img logo-image"
                    src={process.env.PUBLIC_URL + image}
                    alt="정환교 피부과 의원"
                    width="187"
                    height="72"
                    style={{ height: '72px', width: '187px', maxWidth: '100%', objectFit: 'contain' }}
                />
            </div>
        </Link>
    );
};

Logo.propTypes = {
    image: PropTypes.string,
    classOption: PropTypes.string,
    showText: PropTypes.bool,
};

Logo.defaultProps = {
    classOption: "text-center",
    showText: false,
};

export default Logo;
